export default __webpack_public_path__ + "static/media/247.22215d2f.png";